import { AnswerType } from '@app-studio-web/ui/types'
import QuizChoicePage from './QuizChoicePage'

const answers: AnswerType[] = [
  {
    emoji: '🎉',
    title: 'pages.quizOnboarding.situations.answer1',
    value: 'social_group',
  },
  {
    emoji: '🛒',
    title: 'pages.quizOnboarding.situations.answer2',
    value: 'ordering_daily',
  },
  {
    emoji: '💼',
    title: 'pages.quizOnboarding.situations.answer3',
    value: 'work_conversations',
  },
  {
    emoji: '💬',
    title: 'pages.quizOnboarding.situations.answer4',
    value: 'one_on_one',
  },
]

export default function SituationsPage() {
  return (
    <QuizChoicePage
      answers={answers}
      title="pages.quizOnboarding.situations.title"
    />
  )
}
